import React from 'react';
import * as S from './styles';

type Props = {
  children: React.ReactNode;
};

export const TemplatePage = ({ children }: Props) => {
  return <S.TemplatePage>{children}</S.TemplatePage>;
};
